document.addEventListener('DOMContentLoaded', function() {
  var deptBtn    = document.getElementById('departments-btn');
  var panel      = document.getElementById('dept-panel');
  var backBtn    = document.getElementById('back-btn');
  var menuList   = document.getElementById('menu-list');
  var header     = document.getElementById('menu-header');
  var sidePanel  = document.getElementById('fourth-level-panel');

  if (!deptBtn || !panel || !backBtn || !menuList || !header || !sidePanel || typeof menuData === 'undefined') {
    return;
  }

  var stack       = [];
  var titleStack  = [];
  var currentMenu = menuData;

  menuList.style.transition = 'transform 0.25s ease-in-out, opacity 0.15s ease-in-out';
  menuList.style.opacity    = '0';
  menuList.style.transform  = 'translateX(0)';

  function isMobileViewport() {
    return !!(window.matchMedia && window.matchMedia('(max-width: 1024px)').matches);
  }

  function closeFourthOverlay() {
    panel.classList.remove('bs-fourth-open');
    sidePanel.classList.remove('active');
    sidePanel.innerHTML = '';
  }

  function renderFourthLevelMenuMobile(items, parentTitle = '') {
    if (!sidePanel) return;

    const heading = `
      <div class="bs-fourth-header">
        <button type="button" class="bs-fourth-back" aria-label="Back">◀ Back</button>
        <div class="bs-fourth-title">${parentTitle}</div>
      </div>
    `;

    const content = `
      <div class="fourth-grid">
        ${items.map(item => {
          const imgSrc = item.image || 'https://via.placeholder.com/300';
          const href   = item.url || `/collections/${item.handle}`;

          return `
            <div class="ltn__category-item horizontal-card">
              <div class="ltn__category-item-img">
                <a href="${href}">
                  <img src="${imgSrc}" alt="${item.title}" loading="lazy" class="image-position-size"/>
                </a>
              </div>
              <div class="ltn__category-item-name">
                <h5 style="margin:0;">
                  <a href="${href}" style="color: #000; text-decoration: none;">
                    ${item.title}
                  </a>
                </h5>
              </div>
            </div>
          `;
        }).join('')}
      </div>
    `;

    sidePanel.innerHTML = heading + content;
    panel.classList.add('bs-fourth-open');
    sidePanel.classList.add('active');
  }

  function renderMenu(menu, direction) {
    menuList.style.transform = direction === 'in'   ? 'translateX(100%)'
                          : direction === 'out'  ? 'translateX(-100%)'
                          : 'translateX(0)';
    menuList.style.opacity = '0';

    setTimeout(function() {
      header.textContent   = titleStack.length ? titleStack[titleStack.length - 1] : '';
      header.style.display = titleStack.length ? 'block' : 'none';

      menuList.innerHTML = menu.map(function(item, idx) {
        var hasChildren = !!item.children;
        var hasFourthChildren = false;

        // Mobile/tablet only: indicate 4th-level expandability on 3rd-level items
        if (!hasChildren && isMobileViewport() && stack.length === 1 && window.fourthMenuReady && window.fourthLevelMenu) {
          var itemTitle = (item.title || '').toString().trim().toLowerCase();
          var matchKey = Object.keys(window.fourthLevelMenu || {}).find(function(k) {
            return (k || '').toString().trim().toLowerCase() === itemTitle;
          });

          if (matchKey && Array.isArray(window.fourthLevelMenu[matchKey]) && window.fourthLevelMenu[matchKey].length) {
            hasFourthChildren = true;
          }
        }

        return '<li data-index="'+idx+'">'
             +   '<a href="'+(hasChildren ? '#' : (item.href || `/collections/${item.handle}`))+'">'
             +     item.title + ((hasChildren || hasFourthChildren) ? ' ▸' : '')
             +   '</a>'
             + '</li>';
      }).join('');

      backBtn.style.display = stack.length ? 'block' : 'none';
      menuList.style.transform = 'translateX(0)';
      menuList.style.opacity   = '1';
    }, 100);
  }

  function renderFourthLevelMenu(items, parentTitle = '') {
    const panel = document.getElementById('fourth-level-panel');
    if (!panel) return;

    const heading = `<div style="
      font-weight: bold;
      color: #003366;
      font-size: 16px;
      margin-bottom: 10px;
      text-align: left;
    ">${parentTitle}</div>`;

    const content = `
      <div class="fourth-grid">
        ${items.map(item => {
          const imgSrc = item.image || 'https://via.placeholder.com/300';
          const href   = item.url || `/collections/${item.handle}`;

          return `
            <div class="ltn__category-item horizontal-card">
              <div class="ltn__category-item-img">
                <a href="${href}">
                  <img src="${imgSrc}" alt="${item.title}" loading="lazy" class="image-position-size"/>
                </a>
              </div>
              <div class="ltn__category-item-name">
                <h5 style="margin:0;">
                  <a href="${href}" style="color: #000; text-decoration: none;">
                    ${item.title}
                  </a>
                </h5>
              </div>
            </div>
          `;
        }).join('')}
      </div>
    `;

    panel.innerHTML = heading + content;
    panel.classList.add('active');
  }

  deptBtn.addEventListener('click', function(e) {
    e.preventDefault(); e.stopPropagation();
    document.body.classList.add('menu-open');
    panel.classList.add('active');
    stack = [];
    titleStack = [];
    header.style.display = 'none';
    currentMenu = menuData;
    renderMenu(currentMenu, 'in');
    closeFourthOverlay();
  });

  let hoverTimer = null;

  menuList.addEventListener('mouseover', function(e) {
    if (isMobileViewport()) return;
    if (!window.fourthMenuReady) return;
    const li = e.target.closest('li');
    if (!li) return;

    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(() => {
      const idx = +li.getAttribute('data-index');
      const item = currentMenu[idx];
      const depth = stack.length;

      if (depth === 1) {
        const matchKey = Object.keys(window.fourthLevelMenu || {}).find(k =>
          k.trim().toLowerCase() === item.title.trim().toLowerCase()
        );

        if (matchKey) {
          const fourthItems = window.fourthLevelMenu[matchKey];
          renderFourthLevelMenu(fourthItems, item.title);
        } else {
          sidePanel.classList.remove('active');
        }
      }
    }, 100);
  });

  menuList.addEventListener('mouseleave', function () {
    if (isMobileViewport()) return;
    clearTimeout(hoverTimer);
    setTimeout(() => {
      if (!sidePanel.matches(':hover') && !menuList.matches(':hover')) {
        sidePanel.classList.remove('active');
      }
    }, 100);
  });

  menuList.addEventListener('click', function(e) {
    if (!window.fourthMenuReady) {
      console.warn("⚠️ fourthLevelMenu not ready yet.");
      return;
    }

    const li = e.target.closest('li');
    if (!li) return;

    e.preventDefault(); e.stopPropagation();

    const idx = +li.getAttribute('data-index');
    const item = currentMenu[idx];

    if (!item) return;

    const isSecondLevel = stack.length === 0;
    const isThirdLevel  = stack.length === 1;

    const isMobile = isMobileViewport();

    // Mobile/tablet: use the 4th-level panel as an in-drawer overlay (no side-by-side panel)
    if (isMobile) {
      // Clear any previous 4th-level view when changing selection
      closeFourthOverlay();

      if (isThirdLevel) {
        const matchKey = Object.keys(window.fourthLevelMenu || {}).find(k =>
          k.trim().toLowerCase() === item.title.trim().toLowerCase()
        );

        if (matchKey && Array.isArray(window.fourthLevelMenu[matchKey]) && window.fourthLevelMenu[matchKey].length) {
          renderFourthLevelMenuMobile(window.fourthLevelMenu[matchKey], item.title);
          return;
        }
      }
    }

    // → If clicking a 3rd-level without children, follow link
    if (isThirdLevel && !item.children) {
  panel.classList.remove('active');
  closeFourthOverlay();
  document.body.classList.remove('menu-open');
  
  const href = item.href || `/collections/${item.handle}`;
  window.location.href = href;
  return;
}


    // → Proceed with drilldown
    stack.push(currentMenu);
    titleStack.push(item.title);
    currentMenu = item.children || [];

    if (isSecondLevel && !isMobile) {
      // Collect all 4th-level items from children
      const allFourth = [];
      currentMenu.forEach(lvl3 => {
        const key = Object.keys(window.fourthLevelMenu || {}).find(k =>
          k.trim().toLowerCase() === lvl3.title.trim().toLowerCase()
        );
        if (key && Array.isArray(window.fourthLevelMenu[key])) {
          allFourth.push(...window.fourthLevelMenu[key]);
        }
      });

      if (allFourth.length) {
        renderFourthLevelMenu(allFourth, item.title);
      } else {
        sidePanel.classList.remove('active');
        sidePanel.innerHTML = '';
      }
    }

    renderMenu(currentMenu, 'in');
  });

  backBtn.addEventListener('click', function(e) {
    e.preventDefault(); e.stopPropagation();

    if (isMobileViewport() && panel.classList.contains('bs-fourth-open')) {
      closeFourthOverlay();
      return;
    }

    if (stack.length) {
      currentMenu = stack.pop();
      titleStack.pop();
      renderMenu(currentMenu, 'out');
      panel.classList.add('active');
      document.body.classList.add('menu-open');
    }
    closeFourthOverlay();
  });

  document.addEventListener('click', function(e) {
  const clickedOutsidePanel = !panel.contains(e.target);
  const clickedOutsideSidePanel = !sidePanel.contains(e.target);
  const clickedOutsideBoth = clickedOutsidePanel && clickedOutsideSidePanel;
  const notDeptBtn = e.target !== deptBtn;

  if (clickedOutsideBoth && notDeptBtn) {
    if (panel.classList.contains('active')) {
      panel.classList.remove('active');
      document.body.classList.remove('menu-open');
    }
    if (sidePanel.classList.contains('active')) {
      closeFourthOverlay();
    }
  }
});


  panel.addEventListener('click', function(e){ e.stopPropagation(); });
  sidePanel.addEventListener('click', function(e){
    var back = e.target.closest && e.target.closest('.bs-fourth-back');
    if (back) {
      e.preventDefault();
      e.stopPropagation();
      closeFourthOverlay();
      return;
    }
    e.stopPropagation();
  });

});
